import React, { useEffect, useState } from "react";
import { formatNumber, pluralizeText } from "../../../lib/utils";

export default function RaffleGoalProgress(props) {
  //STATE
  const [progress, setProgress] = useState(null);
  const [teamProgress, setTeamProgress] = useState(null);
  const [bonusProgress, setBonusProgress] = useState(null);
  const [startTag, setStartTag] = useState(null);
  const [endTag, setEndTag] = useState(null);
  const [teamTag, setTeamTag] = useState(null);
  const {
    bonusRaffleGoal,
    raffleGoal,
    teamGoal,
    ticketsSold,
    teamTicketsSold,
    message,
    team = false,
  } = props;
  const isInBonusRound = !!bonusRaffleGoal && ticketsSold >= raffleGoal;
  const totalRaffleGoal = raffleGoal + (isInBonusRound ? bonusRaffleGoal : 0);
  useEffect(() => {
    let _startTag, _endTag, _teamTag, _bonusProgress;

    const _progress =
      ticketsSold >= raffleGoal
        ? (raffleGoal / totalRaffleGoal) * 100
        : (ticketsSold / totalRaffleGoal) * 100;

    const _teamProgress =
      teamTicketsSold >= teamGoal ? 100 : (teamTicketsSold / teamGoal) * 100;

    if (isInBonusRound) {
      _bonusProgress =
        ticketsSold >= totalRaffleGoal
          ? 100
          : (ticketsSold / totalRaffleGoal) * 100;
    }

    _startTag = `${formatNumber(ticketsSold)} ${pluralizeText(
      "Ticket",
      ticketsSold
    )} Sold`;
    _endTag = `Goal: ${formatNumber(raffleGoal)}`;

    if (team && !!teamGoal) {
      _teamTag = `${formatNumber(teamTicketsSold)} ${pluralizeText(
        "Ticket",
        teamTicketsSold
      )} out of ${teamGoal} sold`;
    }

    if (isInBonusRound) {
      _startTag += ` - ${
        ticketsSold >= totalRaffleGoal
          ? `Bonus goal of ${formatNumber(totalRaffleGoal)} met`
          : `Original goal of ${formatNumber(raffleGoal)} met`
      }`;
      _endTag =
        ticketsSold < totalRaffleGoal &&
        `Bonus Goal: ${formatNumber(totalRaffleGoal)}`;
    }

    setStartTag(_startTag);
    setEndTag(_endTag);
    setTeamTag(_teamTag);
    setProgress(_progress === 0 ? 0 : Math.max(_progress, 3)); //min of 0 or 3 so bar style works
    setTeamProgress(_teamProgress === 0 ? 0 : Math.max(_teamProgress, 3)); //min of 0 or 3 so bar style works
    setBonusProgress(_bonusProgress);
  }, [
    isInBonusRound,
    raffleGoal,
    ticketsSold,
    totalRaffleGoal,
    team,
    teamTicketsSold,
    teamGoal,
  ]);

  return (
    <div className="raffle-goal-container">
      {!!team && (
        <div className="team-name uppercase-text text-center fs-50 fw-800 mb-32">
          {team.name} Team
        </div>
      )}
      <div className="raffle-goal">
        {team ? (
          <p className="fs-20 fw-600 mb-16"> {message || "Campaign Goal"}</p>
        ) : (
          <p className="brand-color-text mb-32 fs-32 fw-600">
            {message ||
              (isInBonusRound ? "Bonus Goal" : "Our Ticket Sales Goal")}
          </p>
        )}
        <div className={`percentage-bar ${team && "small"} relative`}>
          <div className="bar" />
          {!!bonusProgress && (
            <ProgressComponent progress={bonusProgress} isBonus={true} />
          )}
          {!!progress && <ProgressComponent progress={progress} />}
        </div>
        {!team && (
          <div className="raffle-goal-details">
            <p>{startTag}</p>
            <p>{endTag}</p>
          </div>
        )}
      </div>
      {team && !!teamGoal && (
        <div className="raffle-goal mt-48">
          <p className="brand-color-text mb-32 fs-32 fw-600">Our Team Goal</p>
          <div className={`percentage-bar relative`}>
            <div className="bar" />
            {!!teamProgress && <ProgressComponent progress={teamProgress} />}
          </div>
          <div className="raffle-goal-details">
            <p>{teamTag}</p>
          </div>
        </div>
      )}
    </div>
  );
}
const ProgressComponent = ({ progress, isBonus }) => {
  return (
    <div
      className={`filled-in ${isBonus && "bonus"} ${
        progress <= 92 ? "not-complete" : ""
      }`}
      style={{ width: `${progress}%` }}
    />
  );
};
